import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";

import Spinner from 'react-bootstrap/Spinner';

const { REACT_APP_BACKEND_URL } = process.env;

const DocumentUpload = ({token, data}) => {
  let allowDecline = data && data.allowDecline ? data.allowDecline : false;

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        files: null,
        allowDecline: allowDecline,
        decline: false,
        declineReason: "",
      }}
      validationSchema={Yup.object().shape({
        files: Yup.mixed()
        .test(
          "fileSize",
          "File size(s) too large; max total of 50MB",
          (files) => {
            var sum = 0;
            if (files) 
            {
              for (var i = 0; i < files.length; i++) {
                sum += files[i].size;
              }
              return sum <= (10485760 * 5);  /// Cap it at ~50MB total
            }

            return true;
          }
        )
        .test(
          "required",
          "At least one document is required",
          // Check if decline is checked
          (files, context) => {
            if (allowDecline && context.parent.decline)
            {
              return true;
            }
            
            return files && files.length > 0;
          }
        ),
        decline: Yup.boolean(),
        declineReason: Yup.string().when(["allowDecline", "decline"], {
          is: (allowDecline, decline) => allowDecline && decline,
          then: Yup.string().required("Please provide a declination reason"),
          otherwise: Yup.string()
        }),
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          var formData = new FormData();

          formData.append("data", new Blob([JSON.stringify(
          {
            decline: values.decline,
            declineReason: values.declineReason
            })], {
              type: "application/json"
          }));
          
          if (values.files)
          {
            for (var i = 0; i < values.files.length; i++) 
            {
              formData.append("files", values.files[i]);
            }
          }

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "document/" + token, requestMetadata); 
          if (res.status >= 200 && res.status <= 299)
          {
            window.location.reload();
          }
          else if (res.status === 400)
          {
            setStatus({ success: false });
            alert("Unable to submit; please disable any ad blockers and/or antivirus software and try again. If the problem persists, using a different browser may help.");
            setSubmitting(false);
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          var message = "Something went wrong; please try again";

          if (error instanceof TypeError && error.message === "Failed to fetch")
          {
            message = "Please make sure that no files are open elsewhere on your computer, and then try again.";
          }

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        status,
        touched,
        values,
        getFieldProps,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Please upload a copy of {data.sentToProvider ? "your" : <b>{data.name}'s</b>} most recent: <b>{data.extra && data.extra !== "" ? `${data.extra} ` : ""}{data.documentType}</b></Form.Label>
            <br />
            {allowDecline &&
            <>
            <Form.Label>-- or -- </Form.Label><br />
            <Form.Label>&nbsp;
              <Form.Check
                name="decline"
                style={{display: "inline"}}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.decline}
                checked={values.decline}
              />&nbsp;
              <span style={{fontWeight: "normal"}}>I <b>decline</b> the {data.extra && data.extra !== "" ? `${data.extra} ` : ""}{data.documentType}</span>
            </Form.Label>
            <br />
            {values.decline &&
            <>
            <Form.Label style={{fontWeight: "bold"}}>Declination Reason*</Form.Label>
            <Form.Control
              name="declineReason"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.declineReason}
              isInvalid={Boolean(touched.declineReason && errors.declineReason)}
              />
            {!!touched.declineReason && (
              <Form.Control.Feedback type="invalid">
                {errors.declineReason}
              </Form.Control.Feedback>
            )}
            <br/>
            </>
            }
            </>
            }
            <br />
            <Form.Control
              multiple
              type="file"
              accept="image/*,application/pdf"
              name="files"
              onBlur={handleBlur}
              onChange={(event) => {
                setFieldValue("files", event.currentTarget.files);
              }}
              isInvalid={Boolean(touched.files && errors.files)}
            />
            {!!touched.files && (
              <Form.Control.Feedback type="invalid">
                {errors.files}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <br />
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
          <div id="submitButton" className="text-center mt-3 float-end">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting}
            >
              Submit
            </Button>
          </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before completing the submission</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}
export default DocumentUpload;
